import * as React from 'react';
import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgSpinnerIcon = (
  {
    title,
    titleId,
    desc,
    descId,
    ...props
  }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    fill="none"
    viewBox="0 0 22 22"
    role="img"
    ref={ref}
    aria-labelledby={titleId}
    aria-describedby={descId}
    className="animate-spin"
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <rect
      width={16}
      height={16}
      x={3}
      y={3}
      stroke="#fff"
      strokeWidth={2}
      opacity={0.1}
      rx={8}
    />
    <path stroke="#fff" strokeWidth={2} d="M19 11a8 8 0 0 0-8-8" />
  </svg>
);
const ForwardRef = forwardRef(SvgSpinnerIcon);
const Memo = memo(ForwardRef);
export default Memo;
